// extracted by mini-css-extract-plugin
export default {"file-uploader":"cYoYo","file-uploader--error":"pRnAR","input":"YPhaj","dragging":"F0BRR","text":"YsKGV","text--special":"HJfER","icon":"IQkAV","text--with-icon":"Rfcdp"};